import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.repeat.js";
import "core-js/modules/es.string.starts-with.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
import creditCardType from "credit-card-type";
import moment from "moment-timezone";
import { InputAction } from "../types";
import { parseFullName } from "parse-full-name";
import kebabCase from "lodash/kebabCase";
import i18next from "i18next";
var STREET_ADDRESS_REGEXS = [new RegExp(/^[ A-Za-z0-9_@.,/#&+-]*$/)];
var DEFAULT_TIME_OUT = 3000;
var CA_ZIP_CODE_REGEXS = [new RegExp(/^[A-Za-z]\d[A-Za-z][-]?\d[A-Za-z]\d$/), new RegExp(/([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ]) ?([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])/)];
export var DATE_CONSIDERATIONS = {
  CHECKING_DATE: "2022-01-02",
  DATE_TIME_FORMAT: "YYYY-MM-DD hh:mm A",
  TIME_FORMAT: "h:mm A",
  DATE_FORMAT: "YYYY-MM-DD"
};
export var MOBILE_PAY_PAYMENT_CODE_LENGTH = 13;
export var GeoFenceNotificationRegionState;

(function (GeoFenceNotificationRegionState) {
  GeoFenceNotificationRegionState[GeoFenceNotificationRegionState["Unknown"] = 0] = "Unknown";
  GeoFenceNotificationRegionState[GeoFenceNotificationRegionState["Inside"] = 1] = "Inside";
  GeoFenceNotificationRegionState[GeoFenceNotificationRegionState["Outside"] = 2] = "Outside";
})(GeoFenceNotificationRegionState || (GeoFenceNotificationRegionState = {}));

export var PushNotificationAuthorizationStatus;

(function (PushNotificationAuthorizationStatus) {
  PushNotificationAuthorizationStatus[PushNotificationAuthorizationStatus["AUTHORIZED"] = 100] = "AUTHORIZED";
  PushNotificationAuthorizationStatus[PushNotificationAuthorizationStatus["DENIED"] = 200] = "DENIED";
  PushNotificationAuthorizationStatus[PushNotificationAuthorizationStatus["NOT_DETERMINED"] = 300] = "NOT_DETERMINED";
  PushNotificationAuthorizationStatus[PushNotificationAuthorizationStatus["PROVISIONAL"] = 400] = "PROVISIONAL";
})(PushNotificationAuthorizationStatus || (PushNotificationAuthorizationStatus = {}));

export var CapabilityPermissionStatus;

(function (CapabilityPermissionStatus) {
  CapabilityPermissionStatus[CapabilityPermissionStatus["GRANTED"] = 1000] = "GRANTED";
  CapabilityPermissionStatus[CapabilityPermissionStatus["DENIED"] = 2000] = "DENIED";
  CapabilityPermissionStatus[CapabilityPermissionStatus["BLOCKED"] = 3000] = "BLOCKED";
  CapabilityPermissionStatus[CapabilityPermissionStatus["LIMITED"] = 4000] = "LIMITED";
  CapabilityPermissionStatus[CapabilityPermissionStatus["UNAVAILABLE"] = 5000] = "UNAVAILABLE";
})(CapabilityPermissionStatus || (CapabilityPermissionStatus = {}));

export var ORDER_TYPES;

(function (ORDER_TYPES) {
  ORDER_TYPES[ORDER_TYPES["TOGO_PICKUP"] = 0] = "TOGO_PICKUP";
  ORDER_TYPES[ORDER_TYPES["GIFT_CARD"] = 1] = "GIFT_CARD";
  ORDER_TYPES[ORDER_TYPES["CATERING_DELIVERY"] = 2] = "CATERING_DELIVERY";
  ORDER_TYPES[ORDER_TYPES["CATERING_PICKUP"] = 3] = "CATERING_PICKUP";
  ORDER_TYPES[ORDER_TYPES["ORDER_AHEAD"] = 5] = "ORDER_AHEAD";
})(ORDER_TYPES || (ORDER_TYPES = {}));

export var DecodedOrderType;

(function (DecodedOrderType) {
  DecodedOrderType["TOGO_PICKUP"] = "ToGo Pickup";
  DecodedOrderType["GIFT_CARD"] = "Gift Card";
  DecodedOrderType["CATERING_DELIVERY"] = "Catering Delivery";
  DecodedOrderType["CATERING_PICKUP"] = "Catering Pickup";
  DecodedOrderType["ORDER_AHEAD"] = "Order Ahead";
})(DecodedOrderType || (DecodedOrderType = {}));

export var CurbsideCheckinSource;

(function (CurbsideCheckinSource) {
  CurbsideCheckinSource["SMS"] = "SMS";
  CurbsideCheckinSource["DP_GEO_FENCE_PUSH"] = "DP_GEO_FENCE_PUSH";
  CurbsideCheckinSource["DP_ORDERTRACKING"] = "DP_ORDERTRACKING";
  CurbsideCheckinSource["DP_MOBILE_APP_HOME"] = "DP_MOBILE_APP_HOME";
})(CurbsideCheckinSource || (CurbsideCheckinSource = {}));

var DIGITAL_CHECK_EXCLUSION_ITEMS = ["ToGo See Server"];
var DIGITAL_CHECK_EXCLUSION_SET = new Set(DIGITAL_CHECK_EXCLUSION_ITEMS);
var DIGITAL_CHECK_MODIFIER_PREFIXES = ["No", "On Side", "Light", "With", "Extra", "Sub", "Only", "On Steak"];
var DIGITAL_CHECK_MODIFIER_PREFIX_SET = new Set(DIGITAL_CHECK_MODIFIER_PREFIXES);
export function isValidHttpUrl(str) {
  var pattern = new RegExp("^(https?:\\/\\/)?" + // protocol
  "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
  "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
  "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
  "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
  "(\\#[-a-z\\d_]*)?$", // fragment locator
  "i");
  return pattern.test(str);
}
export function parseDate(str) {
  if (str) {
    try {
      return moment(str, "MM-DD-YYYY").toDate();
    } catch (e) {
      return null;
    }
  } else {
    return null;
  }
}
export function extractNumberFromPixels(pixelString) {
  return parseInt(pixelString.replace("px", ""));
}
export function extractFromFullName(name) {
  var parts = parseFullName(name);

  if ((parts.first === "" || !parts.first) && parts.last) {
    parts.first = parts.last;
    parts.last = null;
  }

  if (!parts.last) {
    parts.last = " ";
  }

  return parts;
}
export function formatDate(d) {
  var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";

  if (d) {
    var month = "" + (d.getMonth() + 1);
    var day = "" + d.getDate();
    var year = d.getFullYear();
    month = month.length < 2 ? "0" + month : month;
    day = day.length < 2 ? "0" + day : day;
    return [month, day, year].join(sep);
  } else {
    return null;
  }
}

var asyncTimeout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(promise) {
    var ms,
        rejectAfterTimeout,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ms = _args.length > 1 && _args[1] !== undefined ? _args[1] : DEFAULT_TIME_OUT;
            rejectAfterTimeout = new Promise(function (resolve, reject) {
              return setTimeout(reject, ms, "timed out");
            });
            return _context.abrupt("return", Promise.race([promise, rejectAfterTimeout]));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function asyncTimeout(_x) {
    return _ref.apply(this, arguments);
  };
}();

export function retryWithTimeout(_x2) {
  return _retryWithTimeout.apply(this, arguments);
}

function _retryWithTimeout() {
  _retryWithTimeout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fn) {
    var retryCount,
        timeOut,
        _yield$handle,
        _yield$handle2,
        err,
        resp,
        newRetry,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            retryCount = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 3;
            timeOut = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : DEFAULT_TIME_OUT;
            _context2.next = 4;
            return handle(asyncTimeout(fn(retryCount), timeOut));

          case 4:
            _yield$handle = _context2.sent;
            _yield$handle2 = _slicedToArray(_yield$handle, 2);
            err = _yield$handle2[0];
            resp = _yield$handle2[1];

            if (!err) {
              _context2.next = 17;
              break;
            }

            if (!(retryCount > 0)) {
              _context2.next = 14;
              break;
            }

            newRetry = retryCount - 1;
            return _context2.abrupt("return", retryWithTimeout(fn, newRetry));

          case 14:
            throw err;

          case 15:
            _context2.next = 18;
            break;

          case 17:
            return _context2.abrupt("return", resp);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _retryWithTimeout.apply(this, arguments);
}

export function formatAMPM(date) {
  var hours = date === null || date === void 0 ? void 0 : date.getHours();
  var minutes = date === null || date === void 0 ? void 0 : date.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  minutes = minutes < 10 ? "0" + minutes : minutes;
  hours = hours < 10 ? "0" + hours : hours;
  return hours + ":" + minutes + " " + ampm;
}
export function formatPhoneNumber(phoneNumberString) {
  if (phoneNumberString) {
    var match = phoneNumberString.replace(/\D+/g, "") // .replace(/^1/, "")
    .match(/([^\d]*\d[^\d]*){1,10}$/)[0];
    var part1 = match.length > 2 ? "(".concat(match.substring(0, 3), ")") : match;
    var part2 = match.length > 3 ? " ".concat(match.substring(3, 6)) : "";
    var part3 = match.length > 6 ? "-".concat(match.substring(6, 10)) : "";
    return "".concat(part1).concat(part2).concat(part3);
  } else {
    return phoneNumberString;
  }
}
export function insertDelimiters(str, positions, delimiter, userAction) {
  if (str && positions && positions.length > 0 && delimiter) {
    var strippedStr = str.split(delimiter).join("");
    var parts = [];
    var positionIndex = 0;
    var position = positions[positionIndex];

    for (var i = 0; i < strippedStr.length; i++) {
      parts.push(strippedStr[i]);

      if (positions.length > positionIndex && i === position - 1) {
        parts.push(delimiter);
        position = positions[++positionIndex];
      }
    }

    var result = parts.join("");

    if (result === [str, delimiter].join("")) {
      return userAction === InputAction.DELETE ? str : result;
    } else {
      return result;
    }
  } else {
    return str;
  }
}
export function isAddressValid(address) {
  if (address) {
    address = address.trim();
    return STREET_ADDRESS_REGEXS.reduce(function (prev, regex) {
      if (prev) {
        return prev;
      } else {
        return regex.test(address);
      }
    }, false);
  } else {
    return false;
  }
}
export function isCityValid(city) {
  if (city) {
    city = city.trim();
    return /^[a-zA-Z\u0080-\u024F]+(?:. |-| |')*([1-9a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/.test(city);
  } else {
    return false;
  }
}
export function isPhoneNumberValid(val) {
  if (val) {
    val = val.trim();
    return /^(\([0-9]{3}\)\s*|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/.test(val);
  } else {
    return false;
  }
}
export function isEmailValid(val) {
  if (val) {
    val = val.trim();
    return /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(val);
  } else {
    return false;
  }
}
export function normalizePhoneNumber(value, previousValue) {
  var _previousValue$replac;

  if (!value) return value;
  var currentValue = value.replace(/[^\d]/g, "");
  var cvLength = currentValue.length;
  var pvLength = previousValue === null || previousValue === void 0 ? void 0 : (_previousValue$replac = previousValue.replace(/[^\d]/g, "")) === null || _previousValue$replac === void 0 ? void 0 : _previousValue$replac.length;

  if (!previousValue || value.length > previousValue.length) {
    // handle autofill on iOS safari phones
    if (pvLength < 9 && cvLength > 10) {
      return "(".concat(currentValue.slice((currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) - 10, (currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) - 7), ") ").concat(currentValue.slice((currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) - 7, (currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) - 4), "-").concat(currentValue.slice((currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) - 4));
    }

    if (cvLength < 4) return currentValue;
    if (cvLength < 7) return "(".concat(currentValue.slice(0, 3), ") ").concat(currentValue.slice(3));
    return "(".concat(currentValue.slice(0, 3), ") ").concat(currentValue.slice(3, 6), "-").concat(currentValue.slice(6, 10));
  } else {
    return value;
  }
}
export function isAlpha(str) {
  if (str) {
    str = str.trim();
    return /^[A-Za-z]+$/.test(str);
  } else {
    return false;
  }
}
export function isAlphaOrContainsSpace(str) {
  if (str) {
    str = str.trim();
    return /^[A-Z a-z]+$/.test(str);
  } else {
    return false;
  }
}
export function isZipValid(str, country) {
  if (str) {
    str = str.trim();

    if (country === "US") {
      return /^\d{5}$/.test(str);
    }

    if (country === "CA") {
      return CA_ZIP_CODE_REGEXS.reduce(function (prev, regex) {
        if (prev) {
          return prev;
        } else {
          return regex.test(str);
        }
      }, false);
    }

    return false;
  } else {
    return false;
  }
}
export function handle(promise, errorExt) {
  return promise.then(function (data) {
    return [null, data];
  })["catch"](function (err) {
    if (errorExt) {
      Object.assign(err, errorExt);
    }

    var fallBackError = new Error("Empty Error Response");
    return [err ? err : fallBackError, undefined];
  });
}
export function hashCode(obj) {
  if (obj) {
    var str = typeof obj === "string" ? obj : sortedStringify(obj, null);

    if (str) {
      return str.split("").reduce(function (prevHash, currVal) {
        return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
      }, 0) + "";
    } else {
      return str;
    }
  } else {
    return null;
  }
}

function flattenEntries(entry) {
  var key = entry[0];
  var value = entry[1];

  if (typeof value !== "object") {
    return [[key, value]];
  }

  if (value) {
    var nestedEntries = Object.keys(value).map(function (k) {
      return [k, value[k]];
    }).map(flattenEntries).reduce(function (acc, arr) {
      return acc.concat(arr);
    }, []);
    nestedEntries.unshift([key, value]);
    return nestedEntries;
  } else {
    return [];
  }
}

export function sortedStringify(obj, sorter) {
  var indent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  if (obj) {
    var sortedKeys = Object.keys(obj).map(function (key) {
      return [key, obj[key]];
    }).map(flattenEntries).reduce(function (acc, arr) {
      return acc.concat(arr);
    }, []).sort(sorter || undefined).map(function (entry) {
      return entry[0];
    });
    return JSON.stringify(obj, sortedKeys, indent);
  } else {
    return "";
  }
}
export function useDebounce(value, delay) {
  var _React$useState = React.useState(value),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      debouncedValue = _React$useState2[0],
      setDebouncedValue = _React$useState2[1];

  React.useEffect(function () {
    var timer = setTimeout(function () {
      return setDebouncedValue(value);
    }, delay);
    return function () {
      clearTimeout(timer);
    };
  }, [value, delay]);
  return debouncedValue;
}
export function getCardTypeInfo(cardType) {
  var cardTypeInfo = null;

  if (!cardType) {
    return cardTypeInfo;
  }

  cardType = cardType.toLowerCase();

  if (cardType === "amex") {
    cardType = "american-express";
  }

  return creditCardType.getTypeInfo(cardType);
}
export function convertHours(mins) {
  var hour = Math.floor(mins / 60);
  var tMins = mins % 60;
  return pad(hour + "", 2) + ":" + pad(tMins + "", 2);
}
export function pad(str, max) {
  return str.length < max ? pad("0" + str, max) : str;
}
/**
 * All timestamps sent by Server are
 * @param currentTimeStamp
 */

export function adjustServerTimestamp(currentTimeStamp) {
  moment.tz.add("America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6");
  var timesx12 = currentTimeStamp ? moment.tz(currentTimeStamp, "America/New_York").format("h:mm A") : "";
  var defaultDate = moment(currentTimeStamp).format("YYYY/MM/DD ").toString();
  return moment(defaultDate + timesx12, timesx12 ? "YYYY/MM/DDh:mm A" : "YYYY/MM/DD").toDate().getTime();
}
export function parseTime(s) {
  if (s) {
    var c = s.split(":");
    return parseInt(c[0]) * 60 + parseInt(c[1]);
  }
}
export function toInteger(s, def) {
  var ret = def;

  if (s) {
    try {
      ret = parseInt(s);
    } catch (e) {//NOOP
    }
  }

  return ret;
}
export function toFloat(s, def) {
  var ret = def;

  if (s) {
    try {
      s = s.replace(/[^\d.\-eE+]/g, "");
      ret = parseFloat(s);
    } catch (e) {//NOOP
    }
  }

  return ret;
}
export function toBoolean(s, def) {
  var ret = def;

  if (s !== null && s !== undefined) {
    try {
      if (typeof s === "boolean") {
        return s;
      } else {
        s = s.toLowerCase();
        return s === "true" ? true : false;
      }
    } catch (e) {//NOOP
    }
  }

  return ret;
}
export function hasCode(str) {
  var hash = 0;

  for (var i = 0; i < str.length; i++) {
    var character = str.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash = hash & hash;
  }

  return hash;
}
/**
 * return time format hh:mm
 * 3:00 -> 03:00
 * 11:59:00 -> 11:59
 * 10:0:0 -> 10:00
 */

export function ensureTimeLength(timeStr) {
  var ret = "";

  if (timeStr) {
    var parts = timeStr.split(":");

    if (parts.length >= 2) {
      var HH = ensure2Digits(parts[0]);
      var mm = ensure2Digits(parts[1]);
      ret = HH + ":" + mm;
    }
  }

  return ret;
}
/**
 *
 * 0 -> 00
 * 12 -> 12
 * 10 -> 10
 * 2 -> 02
 */

export function ensure2Digits(d) {
  if (d.length === 2) {
    return d;
  } else if (d.length === 1) {
    if (d === "0") {
      return "00";
    } else {
      return "0" + d;
    }
  } else {
    return d;
  }
}
export function roundTo(num, decimals) {
  if (num && num > 0) {
    var numStr = num.toFixed(decimals);

    try {
      return parseFloat(numStr);
    } catch (e) {//NOOP
    }

    return num;
  } else {
    return num;
  }
}
export function enforceHTTPS(url) {
  if (url) {
    var lowerUrl = url.toLowerCase();
    var httpsIdx = lowerUrl.indexOf("https://");

    if (httpsIdx === 0) {
      return url;
    } else {
      // does not start with https://
      var httpIdx = lowerUrl.indexOf("http://");

      if (httpIdx === 0) {
        // http url so convert to https
        return ["https://", url.substring(7)].join("");
      } else {
        return ["https://", url].join("");
      }
    }
  } else {
    return url;
  }
}
export function getNoOfDaysBetween(dt1, dt2) {
  return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
}
export function getEnvProps() {
  return process.env;
}

function getISOTimezoneOffset(date) {
  var offset = date.getTimezoneOffset();
  return (offset < 0 ? "+" : "-") + leftPad(Math.floor(Math.abs(offset / 60)) + "", 2) + ":" + leftPad(Math.abs(offset % 60) + "", 2);
}

function leftPad(s, size) {
  while (s.length < (size || 2)) {
    s = "0" + s;
  }

  return s;
}

function getISOLocaleString(date) {
  return date.getFullYear() + "-" + leftPad(date.getMonth() + 1 + "", 2) + "-" + leftPad(date.getDate() + "", 2) + "T" + leftPad(date.getHours() + "", 2) + ":" + leftPad(date.getMinutes() + "", 2) + ":" + leftPad(date.getSeconds() + "", 2) + "." + leftPad(date.getMilliseconds() + "", 3);
}

export function getLocalISODateString(date) {
  return getISOLocaleString(date) + getISOTimezoneOffset(date);
}
export function parseAndConvertDates(obj) {
  if (obj) {
    for (var property in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(property)) {
        var propVal = obj[property];
        var clss = propVal && propVal["@class"];
        var idx = clss ? clss.indexOf("XMLGregorianCalendarImpl") : -1;

        if (idx > 0) {
          try {
            var dtStr = [[propVal.month, propVal.day, propVal.eonAndYear].join("-"), [propVal.hour, propVal.minute, propVal.second].join(":"), "UTC"].join(" ");
            obj[property] = moment(dtStr, "MM-DD-YYYY hh:mm:ss A").toDate();
          } catch (_e) {
            obj[property] = propVal;
          }
        } else {
          if (typeof obj[property] === "object") {
            parseAndConvertDates(obj[property]);
          }
        }
      }
    }
  }

  return obj;
}
export function toStringArray(from) {
  if (from) {
    if (Array.isArray(from)) {
      return from;
    } else {
      return from.split(",");
    }
  } else {
    return null;
  }
}
export function getStringVal(from) {
  if (from) {
    if (Array.isArray(from)) {
      return from.length > 0 ? from.join("") : null;
    } else {
      return from;
    }
  } else {
    return null;
  }
}
export function getBooleanVal(from) {
  if (from) {
    if (Array.isArray(from)) {
      return from.length > 0 && (from[0] === "true" || from[0] === "1") ? true : false;
    } else {
      return from === "true" || from === "1" ? true : false;
    }
  } else {
    return null;
  }
}
export function convertToString(val) {
  if (val) {
    if (typeof val === "object") {
      try {
        val = JSON.stringify(val);
      } catch (e) {// ERROR : Unable to convert object to string
      }
    }

    if (typeof val !== "string") {
      try {
        val = JSON.stringify(val);
      } catch (e) {
        // ERROR : Unable to convert object to string
        val = [val, ""].join("");
      }
    }

    return val;
  } else {
    return val;
  }
}
export function convertFromString(cacheVal) {
  if (cacheVal) {
    if (typeof cacheVal === "string") {
      cacheVal = cacheVal.trim();

      try {
        return JSON.parse(cacheVal);
      } catch (e) {
        return cacheVal;
      }
    } else {
      return cacheVal;
    }
  } else {
    return cacheVal;
  }
}
export function getUniqueId() {
  var _getEnvProps = getEnvProps(),
      NEXT_PUBLIC_REACT_APP_PERSIST_VER = _getEnvProps.NEXT_PUBLIC_REACT_APP_PERSIST_VER;

  if (NEXT_PUBLIC_REACT_APP_PERSIST_VER) {
    return NEXT_PUBLIC_REACT_APP_PERSIST_VER;
  } else {
    var today = moment().toDate();
    return hashCode([today.getDate(), today.getMonth(), today.getFullYear()].join(""));
  }
}

function randomNumber() {
  var seed = new Date().getTime();
  seed = seed & 0xffffffff;
  seed = seed + 0x7ed55d16 + (seed << 12) & 0xffffffff;
  seed = (seed ^ 0xc761c23c ^ seed >>> 19) & 0xffffffff;
  seed = seed + 0x165667b1 + (seed << 5) & 0xffffffff;
  seed = (seed + 0xd3a2646c ^ seed << 9) & 0xffffffff;
  seed = seed + 0xfd7046c5 + (seed << 3) & 0xffffffff;
  seed = (seed ^ 0xb55a4f09 ^ seed >>> 16) & 0xffffffff;
  return (seed & 0xfffffff) / 0x10000000;
}

function uuidv4() {
  var seed = randomNumber();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = seed * 16 | 0,
        v = c == "x" ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

export function getGUID() {
  return uuidv4();
}
export function easeInOutQuad(t, b, c, d) {
  t /= d / 2;

  if (t < 1) {
    return c / 2 * t * t + b;
  }

  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
}
export function easeInCubic(t, b, c, d) {
  var tc = (t /= d) * t * t;
  return b + c * tc;
}
export function inOutQuintic(t, b, c, d) {
  var ts = (t /= d) * t,
      tc = ts * t;
  return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
}
export function debounce(callback, delay) {
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      return callback.apply(void 0, args);
    }, delay);
  };
}
export function showFormattedDecimals(num) {
  var finalResult;

  if (typeof num === "string") {
    if (num.length <= 0) return "";
    var res = num.replace(/[^\d.]/g, "");
    var b = num.replace(/[\d.]/g, "");
    finalResult = b + parseFloat(res).toFixed(2);
  } else {
    finalResult = parseFloat(num).toFixed(2);
  }

  return finalResult.toString();
}
export var formatWithCommaValue = function formatWithCommaValue(val) {
  return val.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
};
export var getLocationString = function getLocationString(address) {
  var _address$context;

  var state = "";
  var splitAddress = address["place_name"].split(","); // if context and state is not present

  if (!address.context || splitAddress.length < 3) {
    return address["place_name"];
  } // dataType means region, postcode, district, locality, address


  (_address$context = address.context) === null || _address$context === void 0 ? void 0 : _address$context.forEach(function (dataType) {
    if (dataType["id"].includes("region.")) {
      if (dataType["short_code"] !== undefined) {
        var _dataType$short_code, _dataType$short_code2; // convert US-NY to NY


        var stateCode = " ".concat((_dataType$short_code = dataType["short_code"]) === null || _dataType$short_code === void 0 ? void 0 : _dataType$short_code.substring(((_dataType$short_code2 = dataType["short_code"]) === null || _dataType$short_code2 === void 0 ? void 0 : _dataType$short_code2.indexOf("-")) + 1));
        var stateWithZipCode = splitAddress.slice(-2)[0];
        state = stateWithZipCode.replace(" ".concat(dataType["text"]), stateCode);
      }
    }
  });

  if (!!state) {
    splitAddress[splitAddress.length - 2] = state;
    return splitAddress.join(",");
  }

  return splitAddress[0];
};
export var getLocationObjectDetails = function getLocationObjectDetails(address) {
  var addressline1 = "",
      place = "",
      region = "",
      postCode = "",
      stateCode = "",
      country = "",
      countyCode = "";

  if (!address.context) {
    return {};
  }

  address.context.forEach(function (dataType) {
    if (dataType["id"].includes("place.")) {
      place = dataType["text"];
    }

    if (dataType["id"].includes("region.")) {
      var _dataType$short_code3, _dataType$short_code4, _dataType$short_code5, _dataType$short_code6;

      stateCode = (_dataType$short_code3 = dataType["short_code"]) === null || _dataType$short_code3 === void 0 ? void 0 : _dataType$short_code3.substring(((_dataType$short_code4 = dataType["short_code"]) === null || _dataType$short_code4 === void 0 ? void 0 : _dataType$short_code4.indexOf("-")) + 1);
      countyCode = (_dataType$short_code5 = dataType["short_code"]) === null || _dataType$short_code5 === void 0 ? void 0 : _dataType$short_code5.substring((_dataType$short_code6 = dataType["short_code"]) === null || _dataType$short_code6 === void 0 ? void 0 : _dataType$short_code6.indexOf("-"), 0);
      region = dataType["text"];
    }

    if (dataType["id"].includes("country.")) {
      country = dataType["text"];

      if (country.indexOf("Canada") >= 0) {
        countyCode = "CA";
      } else {
        countyCode = "US";
      }
    }

    if (dataType["id"].includes("postcode.")) {
      postCode = dataType["text"];
    }
  });
  addressline1 = address["place_name"].split(",")[0];
  return {
    addressLine1: addressline1,
    city: place,
    state: region,
    zipCode: postCode,
    country: country,
    stateCode: stateCode,
    countyCode: countyCode
  };
};
export var formatTimeString = function formatTimeString(time) {
  if (time.slice(-1).toUpperCase() !== "M") {
    time = moment("".concat(DATE_CONSIDERATIONS.CHECKING_DATE, " ").concat(time.slice(0, 5))).format(DATE_CONSIDERATIONS.TIME_FORMAT);
  } else {
    var timeParts = time.split(":");
    time = timeParts[0] + ":" + timeParts[1].slice(0, 2) + " " + timeParts[timeParts.length - 1].slice(-2).toUpperCase();
  }

  return time.trim();
};
/** considerNextDayForSecondTime: will only be applied if AM, am, or Am, is present in the secondTime string. */

export var isFirstParamTimeBigEqual = function isFirstParamTimeBigEqual(firstTime, secondTime) {
  var considerNextDayForSecondTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var considerationDate = DATE_CONSIDERATIONS.CHECKING_DATE;
  var tempDate01 = moment("".concat(considerationDate, " ").concat(formatTimeString(firstTime)), DATE_CONSIDERATIONS.DATE_TIME_FORMAT);
  var formattedSecondTime = formatTimeString(secondTime);

  if (considerNextDayForSecondTime && formattedSecondTime.slice(-2, -1).toUpperCase() === "A") {
    considerationDate = "2022-01-03";
  }

  var tempDate02 = moment("".concat(considerationDate, " ").concat(formattedSecondTime), DATE_CONSIDERATIONS.DATE_TIME_FORMAT);
  return tempDate01.valueOf() >= tempDate02.valueOf();
};
export var isBothTimeEqual = function isBothTimeEqual(firstTime, secondTime) {
  var firstTimeDate = moment("".concat(DATE_CONSIDERATIONS.CHECKING_DATE, " ").concat(formatTimeString(firstTime)), DATE_CONSIDERATIONS.DATE_TIME_FORMAT);
  var secondTimeDate = moment("".concat(DATE_CONSIDERATIONS.CHECKING_DATE, " ").concat(formatTimeString(secondTime)), DATE_CONSIDERATIONS.DATE_TIME_FORMAT);
  return firstTimeDate.isSame(secondTimeDate);
};
export var isTrue = function isTrue(condition, val1, val2) {
  return condition ? val1 : val2;
};
export var isLogicalAnd = function isLogicalAnd(condition1, condition2) {
  return condition1 && condition2;
};
export var isLogicalOR = function isLogicalOR(condition1, condition2) {
  return condition1 || condition2;
};
export var getMaxDobDate = function getMaxDobDate() {
  var minDate = moment().subtract(13, "years").toDate();
  return {
    year: minDate.getFullYear(),
    month: minDate.getMonth(),
    date: minDate.getDate()
  };
};
export var displayDateDIPO = function displayDateDIPO() {
  var getDateSuperScriptForm = function getDateSuperScriptForm(sup) {
    var res = sup.replace(/(\d)(st)/i, "$1ˢᵗ");
    res = res.replace(/(\d)(nd)/i, "$1ⁿᵈ");
    res = res.replace(/(\d)(rd)/i, "$1ʳᵈ");
    res = res.replace(/(\d)(th)/i, "$1ᵗʰ");
    return res;
  };

  return getDateSuperScriptForm("Today, ".concat(moment().format("MMM Do")));
};
export var humanizeDateTime = function humanizeDateTime(dateTime) {
  return dateTime.split(", ")[0] === "Today" || dateTime.split(", ")[0] === "Tomorrow" ? "".concat(dateTime.split(", ")[0], ", ").concat(dateTime.split(", ")[2]) : dateTime;
};
export function ordinalSuffixOf(number) {
  var j = number % 10,
      k = number % 100;

  if (j == 1 && k != 11) {
    return "st";
  }

  if (j == 2 && k != 12) {
    return "nd";
  }

  if (j == 3 && k != 13) {
    return "rd";
  }

  return "th";
}
export function getFormattedPriceByBrand(amount, format) {
  switch (format) {
    case "$xx.xx":
      return "$".concat(amount.toFixed(2));

    case "xx.xx":
      return "".concat(amount.toFixed(2));

    case "$xx":
      return "$".concat(Number(amount.toFixed(2)));

    case "xx":
      return "".concat(Number(amount.toFixed(2)));

    case "s52":
      return "".concat(Number(amount.toFixed(2)));

    default:
      return "$".concat(Number(amount.toFixed(2)));
  }
}
export function constructRestaurantDetailsUrl(_ref2) {
  var state = _ref2.state,
      city = _ref2.city,
      name = _ref2.name,
      id = _ref2.id;

  var _state = kebabCase(state);

  var _city = kebabCase(city);

  var _name = kebabCase(name);

  return "/locations".concat(_state && "/" + _state).concat(_city && "/" + _city).concat(_name && "/" + _name).concat(id ? "/" + id : "");
}
export function getWaitlistButtonLabel(restaurantId, isEditingLocation, isWaitlistJoined, waitlistJoinedRestaurantId) {
  if (isEditingLocation) {
    if (restaurantId == waitlistJoinedRestaurantId) {
      return "selected location";
    } else return "select location";
  } else {
    if (isWaitlistJoined) {
      if (waitlistJoinedRestaurantId) {
        if (restaurantId == waitlistJoinedRestaurantId) {
          return i18next.t("label.locationsearch.editwaitlist.cta", {
            defaultValue: "edit waitlist"
          });
        } else {
          return i18next.t("label.locationsearch.changewaitlist.cta", {
            defaultValue: "change waitlist"
          });
        }
      }
    }
  }

  return i18next.t("label.locationsearch.joinwaitlist.cta", {
    defaultValue: "join waitlist"
  });
} // @ts-ignore

export function joinWaitlistIfStatusAvailable(currentRestaurantNum, WaitlistModel, setIsWaitlistChangeModalOpen) {
  if (WaitlistModel !== null && WaitlistModel !== void 0 && WaitlistModel.waitListId) {
    var _WaitlistModel$restau;

    if ((WaitlistModel === null || WaitlistModel === void 0 ? void 0 : (_WaitlistModel$restau = WaitlistModel.restaurantDetail) === null || _WaitlistModel$restau === void 0 ? void 0 : _WaitlistModel$restau.restaurantNumber) === currentRestaurantNum) {
      return {
        waitListDetails: true
      };
    } else {
      setIsWaitlistChangeModalOpen(true);
    }
  } else {
    return {
      joinWaitlist: true
    };
  }
}
export function getDateInSuperScriptForm(date) {
  return date.replace(/(\d)(st)/i, "$1ˢᵗ").replace(/(\d)(nd)/i, "$1ⁿᵈ").replace(/(\d)(rd)/i, "$1ʳᵈ").replace(/(\d)(th)/i, "$1ᵗʰ");
}
export function getMaskedEmail(email) {
  var fullMasking = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (email) {
    var splittedEmail = email === null || email === void 0 ? void 0 : email.split("@");
    var userName = splittedEmail[0];
    var firstCharOfUsername = userName[0];
    var lastCharOfUsername = userName[userName.length - 1];
    var repeatedMask = "*".repeat(fullMasking ? userName.length - 2 : 3);
    var domainName = splittedEmail[1];
    var maskedMail = "".concat(firstCharOfUsername).concat(repeatedMask).concat(lastCharOfUsername, "@").concat(domainName);
    return maskedMail;
  } else {
    return null;
  }
}

function maskCharacter(str, mask) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return ("" + str).slice(0, -n).replace(/[0-9]/g, mask) + ("" + str).slice(-n);
}

export function getMaskedMobileNumber(mobileNo) {
  var maskLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  return maskCharacter(mobileNo, "*", maskLength);
}
export function getMaskedDOB(dob) {
  return maskCharacter(dob, "*", 4);
}
export var decodeOrderType = function decodeOrderType(orderType) {
  switch (orderType) {
    case ORDER_TYPES.TOGO_PICKUP:
      return DecodedOrderType.TOGO_PICKUP;

    case ORDER_TYPES.GIFT_CARD:
      return DecodedOrderType.GIFT_CARD;

    case ORDER_TYPES.CATERING_DELIVERY:
      return DecodedOrderType.CATERING_DELIVERY;

    case ORDER_TYPES.CATERING_PICKUP:
      return DecodedOrderType.CATERING_PICKUP;

    case ORDER_TYPES.ORDER_AHEAD:
      return DecodedOrderType.ORDER_AHEAD;

    default:
      return null;
  }
};
export var getTypeName = function getTypeName(type) {
  var restDetailsBase = "text.restdetails.hours.";

  switch (type === null || type === void 0 ? void 0 : type.toLowerCase()) {
    case "lunch":
      return i18next.t("".concat(restDetailsBase, "lunch"), {
        defaultValue: type
      });

    case "dinner":
      return i18next.t("".concat(restDetailsBase, "dinner"), {
        defaultValue: type
      });

    case "lounge hours":
      return i18next.t("".concat(restDetailsBase, "loungehours"), {
        defaultValue: type
      });

    case "online ordering":
      return i18next.t("".concat(restDetailsBase, "onlineorder"), {
        defaultValue: type
      });

    case "curbside":
      return i18next.t("".concat(restDetailsBase, "curbside"), {
        defaultValue: type
      });

    case "private dining":
      return i18next.t("".concat(restDetailsBase, "privatedining"), {
        defaultValue: type
      });

    case "tastes and toasts":
      return i18next.t("".concat(restDetailsBase, "tastesandtoasts"), {
        defaultValue: type
      });

    case "happy hour":
      return i18next.t("".concat(restDetailsBase, "happyhour"), {
        defaultValue: type
      });

    default:
      return type;
  }
};
export var appendProtocolToLink = function appendProtocolToLink(link) {
  if (!link) return "";

  if (link.startsWith("http://") || link.startsWith("https://")) {
    return link;
  } else {
    return "https://" + link;
  }
};
export var trimScheduleTime = function trimScheduleTime() {
  var timeString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var HH_MM_SS = timeString.split(" ");
  var HH_MM = HH_MM_SS[0].split(":"); // for Android, as we get different timeString in android

  if (HH_MM_SS.length === 1) {
    var hourValue = parseInt(HH_MM[0].toString());
    if (hourValue === 0) return "12:".concat(HH_MM[1], " AM");
    var isPM = hourValue >= 12;

    if (isPM) {
      var val = hourValue === 12 ? hourValue : hourValue - 12;
      var hour = val < 10 ? "0".concat(val) : val;
      return "".concat(hour, ":").concat(HH_MM[1], " PM");
    }

    return "".concat(HH_MM[0], ":").concat(HH_MM[1], " AM");
  } // for iOS


  return "".concat(HH_MM[0], ":").concat(HH_MM[1], " ").concat(HH_MM_SS[1]);
};
export var zipDeterminer = function zipDeterminer(address) {
  var _address$zipCode, _address$zipCode2;

  var restCountryUSA = (address === null || address === void 0 ? void 0 : address.country) === "US" || (address === null || address === void 0 ? void 0 : address.country) === "USA";
  var zipCodeForCA = (address === null || address === void 0 ? void 0 : address.country) === "CA" && (address === null || address === void 0 ? void 0 : (_address$zipCode = address.zipCode) === null || _address$zipCode === void 0 ? void 0 : _address$zipCode.length) === 6;
  return zipCodeForCA || !restCountryUSA ? address === null || address === void 0 ? void 0 : address.zipCode : (address === null || address === void 0 ? void 0 : (_address$zipCode2 = address.zipCode) === null || _address$zipCode2 === void 0 ? void 0 : _address$zipCode2.substring(0, 5)) || "";
};
export var calculateDistance = function calculateDistance(mapBoxDistance) {
  if (mapBoxDistance === -1) {
    return "<1 mile";
  } else if (mapBoxDistance) {
    var _mapBoxDistance$toStr;

    return ((_mapBoxDistance$toStr = mapBoxDistance.toString()) === null || _mapBoxDistance$toStr === void 0 ? void 0 : _mapBoxDistance$toStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",")) + " miles";
  } else {
    return "";
  }
};
export var isItemExcludedFromDigitalCheck = function isItemExcludedFromDigitalCheck(itemName) {
  return DIGITAL_CHECK_EXCLUSION_SET.has(itemName);
};
export var isModifierHasPrefix = function isModifierHasPrefix(itemName) {
  return DIGITAL_CHECK_MODIFIER_PREFIX_SET.has(itemName);
};
/**
 *
 * @param characterType string
 * @returns :string
 * this function will return characters string on the basis of the type provided
 */

export var getCharacterString = function getCharacterString(characterType) {
  switch (characterType) {
    case "capital":
      return "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    case "smallChar":
      return "abcdefghijklmnopqrstuvwxyz";

    case "numeric":
      return "0123456789";

    case "symbol":
      return "!@#$%^&*";

    default:
      return "";
  }
};
/**
 *
 * @returns string
 *  This function will generate a random 11 characters password containing 1 Uppercase, 6 Lowercase, 1 Symbol and 3 Numbers
 */

export var randomPaswwordGenerator = function randomPaswwordGenerator() {
  var password = "";
  var pattern = [{
    type: "capital",
    occurance: 1
  }, {
    type: "smallChar",
    occurance: 6
  }, {
    type: "symbol",
    occurance: 1
  }, {
    type: "numeric",
    occurance: 3
  }];
  pattern.forEach(function (item) {
    var characterString = getCharacterString(item.type);
    var occuranceIterator = 0;

    while (occuranceIterator < item.occurance) {
      password += characterString.charAt(Math.floor(Math.random() * characterString.length));
      occuranceIterator++;
    }
  });
  return password;
};
export function generateFiveRandomCharacters(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  var counter = 0;

  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }

  return result;
}